import { SET_COOKIE, GET_COOKIE, storeCookie } from "../reducers/cookies"
import {middlewareWrapper} from "utils/middlewareUtils";

export default (cookie = require('react-cookie')) => {

    return [
        middlewareWrapper(setCookie),
        middlewareWrapper(getCookie)
    ]

    function setCookie(store, next, action) {
        if (action.type === SET_COOKIE) {
            cookie.save(action.cookieName, action.value, action.options);
            return next(storeCookie(action.cookieName, action.value));
        }
        return next(action)
    }

    function getCookie(store, next, action) {
        if (action.type === GET_COOKIE) {
            let value = cookie.load(action.cookieName);
            if (value === undefined) {
                if (action.defaultValue === null) {
                    return next(action);
                }

                value = action.defaultValue;
            }
            return next(storeCookie(action.cookieName, value));
        }
        return next(action)
    }    

}


// WEBPACK FOOTER //
// ./modules/Common/middleware/cookies.js